import React, { DragEventHandler, FC, useCallback } from 'react';
import audioEffect from '~/assets/mp3/switch1.mp3';
import { useAudioEffect } from '~/ui/audio-effect/useAudioEffect';
import { LeftMatchItem } from '../QuizMatchStore';
import { CorrectBadge } from './CorrectBadge';
import { IncorrectBadge } from './IncorrectBadge';
import { LeftBorder } from './LeftBorder';
import { LeftShape } from './LeftShape';
import { useColor } from './useColor';
import { DragButton } from '~/ui/buttons/DragButton';
import { t } from 'ttag';

export const LeftMatch: FC<LeftMatchItem & { correct?: boolean }> = ({
  label,
  pairId,
  correct
}) => {
  const [playAudioEffect] = useAudioEffect(audioEffect);
  const dragStartHandler = useCallback<DragEventHandler<HTMLDivElement>>(e => {
    try {
      playAudioEffect();
    } catch (error) {
      // Silently ignore audio effect errors
    }
    e.dataTransfer.setData('text/plain', JSON.stringify({ label, pairId }));
    e.dataTransfer.dropEffect = 'move';
  }, []);

  const color = useColor(correct);

  return (
    <LeftBorder highlightColor={color} className="leftBorder">
      {correct === true ? (
        <CorrectBadge position="absolute" top="0" right="0" />
      ) : (
        ''
      )}
      {correct === false ? (
        <IncorrectBadge position="absolute" top="0" right="0" />
      ) : (
        ''
      )}
      <LeftShape draggable onDragStart={dragStartHandler} className="LeftShape">
        <DragButton />
        {label}
      </LeftShape>
      <div className="dragMe">{t`Drag me`}</div>
    </LeftBorder>
  );
};
